module.exports = __webpack_public_path__ + "img/honor1.05a1b170.png";